import { aiCorrections, aiLab } from './groups/ai.js';
import { compsPromotion } from './groups/comps.js';
import { dashboardsLayouts } from './groups/dashboards.js';
import { dataDeleteSafety, dataFreshness, dataQuality } from './groups/data.js';
import { ingestion } from './groups/ingestion.js';
import { listingsCompliance, listingsExpiry, listingsSignage, listingsWorkload } from './groups/listings.js';
import { propertyManagementLeases } from './groups/property-management.js';
import { propertiesVerification } from './groups/properties.js';
import { requestTrackerDigest } from './groups/request-tracker.js';
import { usersInvites } from './groups/users.js';
/** Build a registry. Throws on two groups with one id. */
export function createSettingsRegistry(groups) {
    const byId = new Map();
    const byKey = new Map();
    for (const g of groups) {
        if (byId.has(g.id))
            throw new Error(`settings registry: group '${g.id}' is defined twice`);
        byId.set(g.id, g);
        for (const def of Object.values(g.settings))
            byKey.set(def.key, def);
    }
    return Object.freeze({
        groups: Object.freeze([...groups]),
        group: (id) => byId.get(id),
        setting: (key) => byKey.get(key),
    });
}
export const SETTINGS_REGISTRY = createSettingsRegistry([listingsCompliance, ingestion, listingsWorkload, propertyManagementLeases, propertiesVerification, listingsExpiry, usersInvites, dataDeleteSafety, aiLab, aiCorrections, compsPromotion, dataQuality, dataFreshness, listingsSignage, dashboardsLayouts, requestTrackerDigest]);
//# sourceMappingURL=registry.js.map